// External libs
import { createReducer } from '@reduxjs/toolkit'
// Interfaces
import { State } from '../interfaces'
// Actions
import actions from '../actions'

export const initialState: State = {
  open: false,
  orderId: 0,
  selectedProduct: '',
  suggestion: '',
}

export default createReducer(initialState, {
  [actions.clearAction.type]: state => clear(state),
  [actions.closeAction.type]: state => close(state),
  [actions.maximizeAction.type]: state => setOpen(state, true),
  [actions.openAction.type]: (
    state,
    { payload: { orderId, selectedProduct, suggestion } },
  ) => open(state, orderId, selectedProduct, suggestion),
})

const clear = (state: State) => {
  return initialState
}

const close = (state: State) => {
  state.open = false
  return state
}

const open = (
  state: State,
  orderId: number,
  selectedProduct: string,
  suggestion: string,
) => {
  state.open = true
  state.orderId = orderId
  state.selectedProduct = selectedProduct
  state.suggestion = suggestion
  return state
}

const setOpen = (state: State, open: boolean) => {
  state.open = open
  return state
}
